import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaylocity = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1566 1558",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "g1",
			x1: 1480.2,
			y1: 1203.5,
			x2: 42.4,
			y2: 1203.5,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#ff8f1c"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#ed2024"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "g2",
			x1: 85.7,
			y1: 353.3,
			x2: 1523.6,
			y2: 353.3,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#ff8f1c"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#ed2024"
			})]
		})] }),
		/* @__PURE__ */ _jsx("style", { children: "\n		.s0 { fill: url(#g1) } \n		.s1 { fill: url(#g2) } \n	" }),
		/* @__PURE__ */ _jsx("g", {
			id: "Layer_2",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Layer_1-2",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Layer",
					fillRule: "evenodd",
					className: "s0",
					d: "m0.2 861.8v-1.4c-0.1-1.2 0-2.4 0.3-3.5 0.3-1.1 0.9-2.2 1.6-3.1 0.7-0.9 1.6-1.7 2.6-2.3 1-0.5 2.1-0.9 3.3-1.1h501.6q1.3 0.1 2.5 0.6 1.2 0.6 2.2 1.4 1 0.9 1.6 2.1 0.7 1.1 0.9 2.4c96.1 363.8 187.2 485.2 266.2 485.2 109.8 0 196.1-235.5 238.6-380.4 3.1-10.5 16.5-6.4 14.7 4.7-90.6 590.8-362.4 590.8-449.7 590.8-273.3-0.4-505-291.9-586.4-695.4zm1565.6-2.5c-79.8 400-311.5 696.6-585.8 696.6q-15.5-0.1-30.9-1.3-15.4-1.3-30.7-3.7-15.2-2.4-30.3-5.9-15-3.6-29.7-8.3-0.4-0.2-0.8-0.4-0.4-0.3-0.8-0.5-0.4-0.3-0.7-0.6-0.3-0.3-0.6-0.7c-1-0.9-1.7-2-2.2-3.2-0.5-1.2-0.7-2.4-0.7-3.7 0-1.3 0.2-2.6 0.7-3.8 0.5-1.2 1.2-2.3 2.2-3.2 136.6-125.6 216-351.5 247.1-662.4q0.1-1.5 0.6-2.9 0.6-1.3 1.6-2.4 1.1-1.1 2.4-1.7 1.4-0.7 2.9-0.8h447.3q1.7 0.1 3.2 0.9 1.5 0.7 2.6 1.9 1.2 1.3 1.7 2.9 0.6 1.5 0.5 3.2z"
				}), /* @__PURE__ */ _jsx("path", {
					id: "Layer",
					fillRule: "evenodd",
					className: "s1",
					d: "m1565.4 695q0 0.1 0 0.3 0 0.2 0 0.3 0 0.2 0 0.3 0 0.2 0 0.3c0.2 1.2 0.2 2.3 0 3.5-0.2 1.1-0.7 2.2-1.3 3.1-0.7 1-1.5 1.8-2.4 2.4-1 0.7-2 1.1-3.2 1.4h-502.1q-1.3-0.1-2.5-0.6-1.2-0.4-2.2-1.3-1-0.9-1.7-2-0.6-1.2-0.8-2.5c-96.1-364.1-187.2-485.5-266.2-485.5-109.8 0-196.1 235.5-238.6 380.5-3.1 10.5-16.5 6.3-14.7-4.8 90.8-590.4 362.7-590.4 449-590.4 274 0 505.7 291.5 586.7 695zm-979.2-694.1q15.4 0.1 30.8 1.3 15.4 1.3 30.7 3.7 15.2 2.5 30.2 6.1 15 3.6 29.7 8.3 0.4 0.2 0.8 0.4 0.4 0.3 0.8 0.5 0.3 0.3 0.7 0.6 0.3 0.3 0.6 0.7c0.9 0.9 1.7 1.9 2.2 3.1 0.5 1.2 0.7 2.5 0.7 3.7 0 1.3-0.2 2.6-0.7 3.8-0.5 1.2-1.3 2.2-2.2 3.1-136.6 124.7-216 351.5-247.1 662.4q-0.1 1.5-0.7 2.9-0.6 1.4-1.7 2.5-1 1-2.4 1.7-1.3 0.6-2.8 0.7h-447.8q-1.7-0.2-3.2-0.9-1.4-0.8-2.5-2-1.1-1.3-1.7-2.9-0.5-1.6-0.4-3.3c79.7-399.8 311.5-696.4 586-696.4z"
				})]
			})
		})
	]
});
export { SvgPaylocity as ReactComponent };
